import { render, staticRenderFns } from "./OwnerNotificationPreviewPage.vue?vue&type=template&id=ef6339f2&scoped=true&"
import script from "./OwnerNotificationPreviewPage.vue?vue&type=script&lang=ts&"
export * from "./OwnerNotificationPreviewPage.vue?vue&type=script&lang=ts&"
import style0 from "./OwnerNotificationPreviewPage.vue?vue&type=style&index=0&id=ef6339f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef6339f2",
  null
  
)

export default component.exports